import './ProcessSection.css';

const steps = [
  {
    step: 'Step 01',
    title: 'Brief us in a 30-minute call',
    body: 'Volume, rails, compliance posture, current pain. We respond with a written scope inside two working days.',
  },
  {
    step: 'Step 02',
    title: 'Compliance & partner fit',
    body: 'KYB documents, AML screening and partner-bank fit. Vetting completes in five working days for standard cases.',
  },
  {
    step: 'Step 03',
    title: 'Start building quickly',
    body: 'Sandbox keys come through fast. Build against idempotent APIs and signed webhooks, with an integration engineer on call.',
  },
  {
    step: 'Step 04',
    title: 'Switch keys and go live',
    body: 'Activate multi-bank routing, turn on monitoring and ship. Optional co-marketing launch when you go live.',
  },
];

export default function ProcessSection() {
  return (
    <section className="process">
      <div className="process__container">
        <div className="process__header">
          <p className="process__eyebrow">How we work</p>
          <h2 className="process__heading">A process built for results</h2>
          <p className="process__subheading">Every step has a published timeline and one person you can call. This is how a kickoff call becomes your first live payout.</p>
        </div>
        <div className="process__grid">
          {steps.map((s, i) => (
            <div key={i} className="process__step">
              <p className="process__step-label">{s.step}</p>
              <h3 className="process__step-title">{s.title}</h3>
              <p className="process__step-body">{s.body}</p>
            </div>
          ))}
        </div>
        <p className="process__footnote">
          Prefer to talk first?{' '}
          <a href="mailto:hello@settlor.money" className="process__link">hello@settlor.money</a>
        </p>
      </div>
    </section>
  );
}
